export const BankAccountsWithBankFeeds = [

    {
        id: 48,
        code: "1004",
        name: "Maybank Savings 8348",
        currency_code: "MYR",
        currency: {
            code: "MYR",
            symbol: "RM",
            name: "Malaysian Ringgit",
        },
        balance: 0,
        reconciled_date: null,
        reconciled_balance: 0,
        system_type: "bank_cash",
        is_deletable: true,
        is_archived: false,
        created_at: "2023-08-10 16:56:44",
        updated_at: "2023-08-10 16:56:44",

        // new keys for bank feeds
        bank_feed_id: 1,
        bank_feed_account_id: 1,
        ext_number: '*****8348',
        // sync_ends_at: '2023-11-06 16:56:44',
    },
    {
        id: 8349,
        code: "1005",
        name: "Maybank2U Current 8349",
        currency_code: "MYR",
        currency: {
            code: "MYR",
            symbol: "RM",
            name: "Malaysian Ringgit",
        },
        balance: 0,
        reconciled_date: null,
        reconciled_balance: 0,
        system_type: "bank_cash",
        is_deletable: true,
        is_archived: false,
        created_at: "2023-08-10 16:56:44",
        updated_at: "2023-08-10 16:56:44",

        // bank: 'maybank',
        // integration_status: BankFeedConnectionStatus.NOT_CONNECTED,

        // new keys for bank feeds
        bank_feed_id: 1,
        bank_feed_account_id: 2,
        ext_number: '*****9123',
        sync_ends_at: '2023-11-06 16:56:44',
    },
    {
        id: 50,
        code: "1006",
        name: "Maybank2E Current 8350",
        currency_code: "MYR",
        currency: {
            code: "MYR",
            symbol: "RM",
            name: "Malaysian Ringgit",
        },
        balance: 0,
        reconciled_date: null,
        reconciled_balance: 0,
        system_type: "bank_cash",
        is_deletable: true,
        is_archived: false,
        created_at: "2023-08-10 16:56:44",
        updated_at: "2023-08-10 16:56:44",

        // bank: 'maybank',
        // integration_status: BankFeedConnectionStatus.PENDING,

        // new keys for bank feeds
        bank_feed_id: 1,
        bank_feed_account_id: 3,
        ext_number: '*****1234',
        sync_ends_at: '2023-11-06 16:56:44',
    },
    // {
    //     id: 51,
    //     code: "107",
    //     name: "Maybank2E Current ARCHIVED",
    //     currency_code: "MYR",
    //     currency: {
    //         code: "MYR",
    //         symbol: "RM",
    //         name: "Malaysian Ringgit",
    //     },
    //     balance: 0,
    //     reconciled_date: null,
    //     reconciled_balance: 0,
    //     system_type: "bank_cash",
    //     is_deletable: true,
    //     is_archived: true,
    //     created_at: "2023-08-10 16:56:44",
    //     updated_at: "2023-08-10 16:56:44",

    //     // bank: 'maybank',
    //     // integration_status: BankFeedConnectionStatus.NOT_CONNECTED,

    //     // new keys for bank feeds
    //     bank_feed_id: 1,
    //     bank_feed_account_id: '4382',
    //     sync_ends_at: '2023-11-06 16:56:44',
    // },
    {
        id: 79123,
        code: "1018",
        name: "ANZ Savings",
        currency_code: "AUD",
        currency: {
            code: "AUD",
            symbol: "AU$",
            name: "Australian Dollar",
        },
        balance: 0,
        reconciled_date: null,
        reconciled_balance: 0,
        system_type: "bank_cash",
        is_deletable: true,
        is_archived: false,
        created_at: "2023-07-24 12:44:32",
        updated_at: "2023-07-24 12:44:32",

        // new keys for bank feeds
        bank_feed_id: null,
        bank_feed_account_id: null,
        sync_ends_at: null,
    },
    {
        id: 82,
        code: "USD-HIHI-123",
        name: "USD HIHI Account Banking",
        currency_code: "USD",
        currency: {
            code: "USD",
            symbol: "$",
            name: "US Dollar",
        },
        balance: 0,
        reconciled_date: null,
        reconciled_balance: 0,
        system_type: "bank_cash",
        is_deletable: true,
        is_archived: false,
        created_at: "2023-11-09 10:46:22",
        updated_at: "2023-11-09 10:46:22",

        // new keys for bank feeds
        bank_feed_id: null,
        bank_feed_account_id: null,
        sync_ends_at: null,
    },
    {
        id: 2000,
        code: "1000-00-dummy",
        name: "Cash on Hand",
        currency_code: "MYR",
        currency: {
            code: "MYR",
            symbol: "RM",
            name: "Malaysian Ringgit",
        },
        balance: 0,
        reconciled_date: null,
        reconciled_balance: 0,
        system_type: "bank_cash",
        is_deletable: true,
        is_archived: false,
        created_at: "2022-03-18 11:46:26",
        updated_at: "2022-03-18 11:46:26",

        // new keys for bank feeds
        bank_feed_id: null,
        bank_feed_account_id: null,
        sync_ends_at: null,
    },

];
